var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import sendAPIRequest from '../../helpers/api/plugNmeetAPI';
import { toast } from 'react-toastify';
import { store } from '../../store';
import { ApproveWaitingUsersReq, CommonResponse, RemoveParticipantReq, } from '../../helpers/proto/plugnmeet_common_api_pb';
const ParticipantsList = ({ waitingParticipants }) => {
    _react_refresh_temp_2();
    const { t } = useTranslation();
    const acceptUser = async (userId) => {
        const body = new ApproveWaitingUsersReq({
            userId: userId,
        });
        const r = await sendAPIRequest('waitingRoom/approveUsers', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('left-panel.menus.notice.user-approved', { name: name }), {
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                type: 'error',
            });
        }
    };
    const rejectUser = async (userId, block) => {
        const session = store.getState().session;
        const body = new RemoveParticipantReq({
            sid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            userId: userId,
            msg: t('notifications.you-have-reject').toString(),
            blockUser: block,
        });
        const r = await sendAPIRequest('removeParticipant', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('left-panel.menus.notice.participant-removed'), {
                toastId: 'user-remove-status',
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                type: 'error',
            });
        }
    };
    const renderWaitingParticipants = () => {
        return waitingParticipants.map((p) => {
            return (_jsxs("div", { className: "waiting-list-item mb-2 pb-2 border-b border-solid border-primaryColor w-full max-w-max", children: [_jsx("p", { className: "text-base text-black dark:text-darkText", children: p.name }), _jsx("button", { onClick: () => acceptUser(p.userId), className: "text-xs text-white py-[1px] px-2 rounded-lg transition ease-in bg-primaryColor hover:bg-secondaryColor", children: t('left-panel.approve') }), _jsx("button", { onClick: () => rejectUser(p.userId, false), className: "text-xs text-white py-[1px] px-2 rounded-lg transition ease-in bg-red-600 hover:bg-red-800 ltr:ml-2 rtl:mr-2", children: t('left-panel.reject') }), _jsx("button", { onClick: () => rejectUser(p.userId, true), className: "text-xs text-white py-[1px] px-2 rounded-lg transition ease-in bg-red-600 hover:bg-red-800 ltr:ml-2 rtl:mr-2", children: t('waiting-room.reject-and-block-user') })] }, p.userId));
        });
    };
    return (_jsxs("div", { className: "waiting-list-wrap", children: [_jsx("p", { className: "text-lg my-4 text-black dark:text-white font-bold ltr:text-left rtl:text-right", children: t('waiting-room.list-waiting-participants', {
                    count: waitingParticipants.length,
                }) }), _jsx("div", { className: "waiting-list scrollBar h-[130px] overflow-auto", children: _jsx("div", { className: "waiting-list-inner", children: renderWaitingParticipants() }) })] }));
};
_react_refresh_temp_1 = ParticipantsList;
$RefreshReg$(_react_refresh_temp_1, "ParticipantsList");
_react_refresh_temp_2(ParticipantsList, "zlIdU9EjM2llFt74AbE2KsUJXyM=", false, () => [useTranslation]);
export default ParticipantsList;
